import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { YachtsFiltersFormT } from "./yachts-filters.schema";
import { Checkbox } from "@/src/components/ui/checkbox";

const types = [
  {
    id: "synced",
    label: "Available in API",
  },
  {
    id: "delayed",
    label: "Temporarily missing from API",
  },
  {
    id: "expired",
    label: "Missing from API",
  },
] as const;

export const APIStatuses = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Yachts API statuses</h3>
      <FormField<YachtsFiltersFormT, "apiStatus">
        name="apiStatus"
        render={() => (
          <FormItem>
            {types.map((item) => (
              <FormField
                key={item.id}
                name="apiStatus"
                render={({ field }) => {
                  return (
                    <FormItem key={item.id} className="flex flex-row items-start space-x-3 space-y-0">
                      <FormControl>
                        <Checkbox
                          className="w-6 h-6"
                          checked={field.value?.includes(item.id)}
                          onCheckedChange={(checked) => {
                            return checked
                              ? field.onChange([...field.value, item.id])
                              : field.onChange(field.value?.filter((value: any) => value !== item.id));
                          }}
                        />
                      </FormControl>
                      <FormLabel className="font-normal text-base leading-6">{item.label}</FormLabel>
                    </FormItem>
                  );
                }}
              />
            ))}
          </FormItem>
        )}
      />
    </div>
  );
};
